import React, { useState, useEffect } from "react";
import { Drawer } from "@mui/material";
import SnackAlert from "../../../shared/SnackAlert";
import Spinner from "../../../shared/Spinner";
import ConfirmDiallog from "../../../shared/ConfirmDiallog";
import permitServices from "../../../services/permit-service";
import AddPermit from "./AddPermit";
import PermitsView from "./PermitsView";
import organizationServices from "../../../services/organization-service";
import cityServices from "../../../services/city-service";
import moment from "moment";

export default function ManagePermits(props) {
  const [openDialog, setOpenDialog] = useState(false);
  const [spinner, setSpinner] = useState(false);
  const [msg, setMsg] = useState("");
  const [alert, setAlert] = useState(false);
  const [severity, setSeverity] = useState("");
  const [openDrawer, setOpenDrawer] = useState(false);
  const [inputField, setInputField] = useState({});
  const [permits, setPermits] = useState([])
  const [editId, setEditId] = useState('');
  const [btn, setBtn] = useState(props.literals.add);
  const [selectedOrg, setSelectedOrg] = useState(null)
  const [selectedZone, setSelectedZone] = useState(null)
  const [organizations, setOrganizations] = useState([])
  const [zones, setZones] = useState([])
  const [permitDetail, setPermitDetail] = useState([]);
  const [open, setOpen] = React.useState('');
  
  const user = JSON.parse(sessionStorage.getItem('userLogged'));

  useEffect(()=>{
    getOrganizations();
    getPermits();
  },[])

  const getOrganizations = async()=>{
    setSpinner(true);
    const res = await organizationServices.getOrganizations();
    if(user.result?.role !== 'root'){
      let org = res.data.filter(x=>x._id == props.org._id);
      setSelectedOrg(org[0]);
      onOrgSelected(org[0]);
    }
    setOrganizations(res.data)
    setSpinner(false);
  }

  const getPermits = async()=>{
    setSpinner(true);
    const res = await permitServices.getPermits({org_id: props.org._id});
    setPermits(res.data)
    setSpinner(false);
  }

  const onOrgSelected = async (e)=>{
    setSelectedOrg(e);
    setSelectedZone(null);
    setSpinner(true);
    const res = await cityServices.getZones({org_id: e._id});
    setZones(res.data)
    setSpinner(false);
  }

  const handleChange = (e) => {
    setInputField({ ...inputField, [e.target.name]: e.target.value });
  };

  const handleCheck = (e) => {
    setInputField({ ...inputField, [e.target.name]: e.target.checked });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    inputField['org'] = selectedZone.org._id;
    inputField['zone'] = selectedZone._id;
    if(btn === props.literals.add){
      await permitServices.addPermit(inputField);
      setMsg(props.literals.permit_added_successfully);
      setSeverity('success');
      setAlert(true);
    }else{
      inputField['id'] = editId;
      await permitServices.editPermit(inputField);
      setBtn(props.literals.add)
      setMsg(props.literals.permit_updated_successfully);
      setSeverity('success');
      setAlert(true);
      setOpen('');
    }
    getPermits();
    setInputField({});
    setOpenDrawer(false);
    setSpinner(false);
  };

  const delItem=async()=>{
    setSpinner(true);
    await permitServices.delPermit({id: editId});
    getPermits();
    setOpen('');
    setSpinner(false);
    setOpenDialog(false);
    setMsg(props.literals.permit_deleted_successfuly)
    setSeverity('success')
    setAlert(true)
  }

  const onEdit = async(e)=> {
    if(e.permit_type == 'custom'){
      e.permit_start_date = moment(e.permit_start_date).format('YYYY-MM-DD');
      e.permit_end_date = moment(e.permit_end_date).format('YYYY-MM-DD');
    }
    setInputField(e);
    setSelectedOrg(organizations.find(x => x._id == e.org));
    setSpinner(true);
    const res = await cityServices.getZones({org_id: e.org});
    setZones(res.data)
    setSpinner(false);
    setSelectedZone(res.data.find(x => x._id == e.zone));
    setOpenDrawer(true);
    setEditId(e._id);
    setBtn(props.literals.update);
  }

  const getDetail = async(e)=>{
    setPermitDetail(e.permits);
  }

  return (
    <>
    <PermitsView
      permits={permits}
      literals={props.literals}
      permitDetail = {permitDetail}
      open = {open}

      setOpen = {(e)=>setOpen(e)}
      onEdit={(e)=>onEdit(e)}
      delItem={(id) => {setEditId(id); setOpenDialog(true)}}
      setOpenDrawer={()=>setOpenDrawer(!openDrawer)}
      getDetail = {(e)=>getDetail(e)}
      />
    <Drawer
      PaperProps={{
        sx: {
          backgroundColor: "#fff !important",
          width:
            window.innerWidth > 700
              ? "35% !important"
              : "100% !important",
        },
      }}
      anchor={'right'}
      open={openDrawer}
      onClose={()=>setOpenDrawer(false)}
    >
      <AddPermit
        inputField={inputField}
        btn={btn}
        organizations={organizations}
        zones={zones}
        selectedOrg={selectedOrg}
        selectedZone={selectedZone}
        user={user}
        literals = {props.literals}
        
        onOrgSelected = {(e)=> onOrgSelected(e)}
        setSelectedZone={(e)=>setSelectedZone(e)}
        handleCheck={(e)=>handleCheck(e)}
        handleChange={(e)=>handleChange(e)}
        handleSubmit={(e)=>handleSubmit(e)}
        onClose={()=>setOpenDrawer(false)}
      />
      </Drawer>

      <SnackAlert
        msg = {msg}
        alert = {alert}
        severity = {severity}
        
        closeAlert = {()=>setAlert(!alert)}
      />
      <Spinner
        spinner = {spinner}
      />
      <ConfirmDiallog
        openDialog = {openDialog}

        closeDialog = {()=>setOpenDialog(false)}
        delItem = {()=>delItem()}
      />
    </>
  );
}
